import DashboardConfig from "pages/Dashboard/DashboardConfig";
import LoginConfig from "pages/Login/LoginConfig";
import NoPageConfig from "pages/NoPage/NoPageConfig";

const layouts = [DashboardConfig, LoginConfig, NoPageConfig];

export default layouts;
